import { useQuery } from "@apollo/client";
import { clientCentralApiStrawberry } from "@neonumy/api-clients";
import NewRaiLogo from "resources/images/NEWRAI-FOND-BLANC.png";
import { GET_ACCOUNTING_FIRM_LOGO_AND_SETTINGS } from "queries/centralApi/accountingFirms";
import useCoreStore from "views/hooks/useCoreStore";

const NEWRAI_DOMAINS = ["newrai.fr", "neonumy.dev", "localhost"];

function isNewraiDomain(hostname: string): boolean {
  return NEWRAI_DOMAINS.some(domain => hostname === domain || hostname.endsWith(`.${domain}`));
}

export default function useGetLogo() {
  const hostname = window.location.hostname;
  const accountingFirmSelected = useCoreStore(state => state.accountingFirmSelected);
  const accountingFirmId = accountingFirmSelected?.id;

  const { data } = useQuery<
    GetAccountingFirmLogoAndSettingsResponse,
    GetAccountingFirmLogoAndSettingsInput
  >(GET_ACCOUNTING_FIRM_LOGO_AND_SETTINGS, {
    client: clientCentralApiStrawberry,
    variables: { id: accountingFirmId },
    skip: isNewraiDomain(hostname) || !accountingFirmId,
  });
  if (isNewraiDomain(hostname)) {
    return { generateByLogo: NewRaiLogo, accountingFirmName: "NewRai" };
  }

  const domains: string[] = data?.getAccountingFirmSettings?.domains ?? [];
  if (domains.some(domain => hostname === domain || hostname.endsWith(`.${domain}`))) {
    return {
      generateByLogo: data?.getAccountingFirm?.logo || null,
      accountingFirmName: data?.getAccountingFirm?.name || null,
    };
  }

  return { generateByLogo: null, accountingFirmName: null };
}
